import { setMtaLibCurPage, initMtaLib } from './mta-lib';
import { getParamAdtag } from '../url';
import { getUin } from '../user';
import { adtagInit, checkAdtagReady, getAdtag, setNoNeedAdtag} from '../adtagUtil';
import { setNoSessionTraceId } from '../traceUtil';
import { clearFullReport } from './full-report';
import { getUrlParam } from '../url';

let curPageName = 'index';
let globalExtraBiParam = {};
/**
 * 设置当前页面名称
 * @param {}} pageName
 */
export function registGlobalBiParam(param) {
  globalExtraBiParam = Object.assign(globalExtraBiParam, param);
}

/**
 * 设置当前页面名称
 * @param {}} pageName
 */
export function setCurPageName(pageName) {
  curPageName = pageName || 'index';
  setMtaLibCurPage(getCurPage());
}

/**
 * 获取当前页面
 * 当前页面名字 ${packageJson.name}_${routerName}
 */
function getCurPage() {
  return `${report_source}.page_${curPageName}`;
}

const Mta = {
  stats: [],
  url: '',
  fn: function () { } //mta基础加载好后的回调
};

const Util = {
  sessionCache: {
    setItem: function (key, data) {
      try {
        sessionStorage.setItem(key, JSON.stringify(data));
      } catch (e) {
        return '';
      }
    },
    getItem: function (key) {
      try {
        var dataStr = sessionStorage.getItem(key);

        return Util.parseJSON(dataStr);
      } catch (e) {
        return '';
      }
    }
  },
  storageCache: {
    setItem: function (key, data) {
      try {
        localStorage.setItem(key, JSON.stringify(data));
      } catch (e) {
        return '';
      }
    },
    getItem: function (key) {
      try {
        var dataStr = localStorage.getItem(key);

        return Util.parseJSON(dataStr);
      } catch (e) {
        return '';
      }
    }
  },
  parseJSON: function (data) {
    //对JSON原生的parse方法进行兼容
    if (!data || typeof data != 'string') {
      return data;
    }
    try {
      data = JSON.parse(data);
    } catch (e) {
      data = new Function('return ' + data)();
    }
    return data;
  }
};

//为了避免上报卡住微信的绿条加载，会导致jsapi无法调用
let isWindowLoaded = false;
window.addEventListener('load', () => {
  setTimeout(() => {
    isWindowLoaded = true;
  }, 2000);
});

var MtaStat = {
  sid: '',
  domain: '',
  baseBiPrams: {},
  /** 初始化mta需要的数据
   * params {
   *  sid
   *  cid
   *  domain 加载mta库文件的cdn域名
   * }
   */
  init: function (params, baseBiPrams) {
    if (isWindowLoaded) {
      this._init(params, baseBiPrams);
    } else {
      window.addEventListener('load', () => {
        setTimeout(() => {
          this._init(params, baseBiPrams);
        }, 2000);
      });
    }
  },

  _init: function (params, baseBiPrams) {
    params = params || {};

    if (params.sid) {
      this.initMta(params.sid, params.cid, params.domain);
      this.sid = params.sid;
      this.domain = params.domain;
      this.baseBiPrams = baseBiPrams;
    }
    var hotTag = getParamAdtag();

    if (hotTag) {
      this.clickStat(hotTag);
    }
  },
  /**
   * @param str
   * @param params mta定义的参数
   * @param biParams bi数据分析所需参数
   *      fuin 用户支付id（选传）
   *      fpre_event_id 上一个点击流  组件默认处理可不传
   *      fopenid 必传
   *      fchannel_id 渠道id（选传）
   *      isPageFunnel 是页面漏斗模式还是点击流漏斗， 默认是点击流漏斗
   * @param delayReport 是否延迟上报，开启该功能，会缓存点击流，在下一个页面加载后上报
   */
  clickStat: function (str, params, biParams, delayReport) {
    var i = 0;
    var biNeedStatStr = '';
    biParams = biParams || {};

    if (!str) {
      return false;
    }
    str = str.replace(/\./g, '_');

    //MTA漏斗上报方式转化成BI所需数据格式
    if (params) {
      for (var key in params) {
        i++;
        biNeedStatStr = key;
      }

      if (i < 2) {
        this.cacheEventId(str, biNeedStatStr);

        biParams['fpre_event_id'] = this.getPreEventId(str, biNeedStatStr);
        biParams.furl = getCurPage();
        biParams.fpathname = location.pathname;


        this.sendByMta(
          str.replace('46', '.') + '.' + biNeedStatStr.replace('46', '.'),
          {},
          biParams,
          delayReport
        );
      }
    }

    this.sendByMta(str, params, null, delayReport);
  },

  //页面请求上传，默认进行bi数据上报
  pgv: function (hash, biParams) {
    biParams = biParams || {};
    hash = hash ? '#' + hash : location.hash;

    var recordUrl = this.getCacheUrl() || '';
    var newUrl = getCurPage();

    var lastRecordUrl = recordUrl.substring(recordUrl.lastIndexOf('|') + 1);
    if (recordUrl && -1 === lastRecordUrl.indexOf(newUrl)) {
      //避免刷新的时候，当前页面不停叠加到漏斗路径
      newUrl = recordUrl + '|' + newUrl;
      newUrl = this.deleteExceedUrl(newUrl);
    }

    if (recordUrl && newUrl !== recordUrl) {
      biParams['fpre_event_id'] = recordUrl;
    }

    //缓存url访问记录
    this.cacheUrl(newUrl);

    if (window.MtaH5) {
      window.MtaH5 && window.MtaH5.pgv(null, biParams);
    } else {
      Mta.url = {
        biParams: biParams
      };
    }
  },

  loadHotClick: function (hid) {
    var _this = this;

    var fn = function () {
      var script = document.createElement('script');
      var domain = _this.domain || 'mqq-imgcache.gtimg.cn';

      script.type = 'text/javascript';
      script.setAttribute('name', 'mtah5hotclick');
      script.setAttribute('sid', _this.sid);
      script.setAttribute('hid', hid);
      script.src =
        'https://' + domain + '/res/g/js/lib/stat/mta-hotclick.js?v=20190509a';
      script.async = true;
      document.body.appendChild(script);
    };

    if (window.MtaH5) {
      window.MtaH5 && fn();
    } else {
      Mta.fn = fn;
    }
  },

  //只保存10条url记录，多余删除
  deleteExceedUrl: function (urlList) {
    var urlArr = urlList.split('|');

    if (urlArr.length > 10) {
      urlArr.shift();
    }

    return urlArr.join('|');
  },
  sendByMta: function (evtName, params, biParams, delayReport) {
    //延迟上报的上报请求缓存起来
    if (delayReport) {
      var dataArr = Util.storageCache.getItem('mta_stat_arr') || [];

      dataArr.push({
        evtName: evtName,
        params: params,
        biParams: biParams
      });

      Util.storageCache.setItem('mta_stat_arr', dataArr);
      return;
    }
    if (typeof window.MtaH5 != 'undefined') {
      window.MtaH5 && window.MtaH5.clickStat(evtName, params, biParams);
    } else {
      Mta.stats.push({
        evtName: evtName,
        params: params,
        biParams: biParams
      });
    }
  },
  initMta: function (sid, cid, domain) {
    //this.loadJS(sid, cid, domain, () => {
    initMtaLib(sid, cid);
    for (var i = 0; i < Mta.stats.length; i++) {
      window.MtaH5.clickStat(
        Mta.stats[i]['evtName'],
        Mta.stats[i]['params'],
        Mta.stats[i]['biParams']
      );
    }

    if (Mta.url) {
      window.MtaH5.pgv(null, Mta.url.biParams);
    }

    if (Mta.fn) {
      Mta.fn();
    }
    //上报缓存的点
    this.reportCacheStat();

    //监听点击事件
    this.listenClick();
    //});
  },

  //上报缓存的点
  reportCacheStat: function () {
    var dataArr = Util.storageCache.getItem('mta_stat_arr') || [];

    //遍历存储的点
    for (var i = 0, len = dataArr.length; i < len; i++) {
      (function (obj) {
        setTimeout(function () {
          window.MtaH5.clickStat(obj.evtName, obj.params, obj.biParams);

          dataArr.shift();

          //可能中途被打断，再存一遍
          Util.storageCache.setItem('mta_stat_arr', dataArr);
        }, 50);
      })(dataArr[i]);
    }
    Util.storageCache.setItem('mta_stat_arr', []);
  },

  /**
   * 获取上一个点击流
   * @private
   */
  getPreEventId: function (evtName, paramStr) {
    var arr = Util.sessionCache.getItem(this.sid + evtName) || [];
    var preEventId = '';

    for (var i = 0, len = arr.length; i < len; i++) {
      if (paramStr === arr[i] && i > 0) {
        preEventId = (evtName + '.' + arr[i - 1]).replace(/46/g, '.');
      }
    }
    return preEventId;
  },
  //缓存点击流
  cacheEventId: function (evtName, paramStr) {
    //缓存上一个点
    var arr = Util.sessionCache.getItem(this.sid + evtName) || [];
    var hasRecord = false;

    for (var i = 0, len = arr.length; i < len; i++) {
      if (paramStr === arr[i]) {
        hasRecord = true;
      }
    }
    if (!hasRecord) {
      Util.sessionCache.setItem(this.sid + evtName, arr.concat([paramStr]));
    }
  },
  //缓存页面url请求
  cacheUrl: function (url) {
    Util.sessionCache.setItem(this.sid + 'NewUrlRecord2020', url);
  },

  //获取存储的url
  getCacheUrl: function () {
    return Util.sessionCache.getItem(this.sid + 'NewUrlRecord2020') || '';
  },

  loadJS: function (sid, cid, domain, callback) {
    var script = document.createElement('script');
    domain = domain || 'mqq-imgcache.gtimg.cn';
    script.type = 'text/javascript';
    script.setAttribute('name', 'MTAH5');
    script.setAttribute('sid', sid || '500008935');
    script.setAttribute('cid', cid || '500009774');
    script.src =
      'https://' + domain + '/res/g/js/lib/stat/mta-lib.js?v=20190505';
    script.async = true;
    var onload = function () {
      callback && callback();
    };

    if ('onload' in script) {
      script.onload = onload;
    } else {
      script.onreadystatechange = function () {
        if (/loaded|complete/.test(script.readyState)) {
          onload();
        }
      };
    }
    document.body.appendChild(script);
  },
  /**
   * 监听点击事件,BI热力图使用
   * 页面元素需增加data-stat 和对应的点击流
   */
  listenClick: function () {
    var _this = this;

    document.addEventListener('touchstart', function (e) {
      var target = e.target;
      var stat = target.getAttribute('data-stat');

      if (stat) {
        window.MtaH5 && window.MtaH5.clickStat(stat, null, _this.baseBiPrams);
      }
    });
  }
};

let report_source = '';
let report_need_login = false;

// sid = '500008935', cid = '500009774', domain = 'st.moneydata.hk'
// 这块默认是香港钱包在bi那边的配置
// 如果其他业务要用，可以传递sid, cid， domain进去重写
export function init(option) {
  option = option || {};
  const {
    source = 'unknow',
    reportNeedLogin = true,
    sid = '500008935',
    cid = '500009774',
    domain = 'st.moneydata.hk',
  } = option;
  report_source = source;
  report_need_login = !!reportNeedLogin;
  const urlNoAdtag =  +getUrlParam("noAdtagTransfer") === 1; //临时补丁，兼容老的noAdtagTransfer
  if (option.noAdtag || urlNoAdtag || /app_7_88/.test(location.href)) {
    //之前大促小程序中为了兼容小程序不加载iframe，增加了noAdtag, 为了兼容，同时在sessionTraceId也屏蔽
    setNoNeedAdtag();
    setNoSessionTraceId();
    //后续还是干掉这个逻辑，在这个模块做，不好
  }

  MtaStat.init({
    sid,
    cid,
    domain
  });

  if (isWindowLoaded) {
    adtagInit();
  } else {
    window.addEventListener('load', () => {
      setTimeout(() => {
        adtagInit();
      }, 2000);
    });
  }
}

export function checkReady() {
  const promiseList = [];
  promiseList.push(checkMtaReady());
  promiseList.push(checkAdtagReady());
  return Promise.all(promiseList);
}

export function checkMtaReady() {
  return Promise.resolve(true);
}

//bi版本上报
export function biHottag(tag, extBiParams) {
  console.log('biHottag:' + tag);
  // 清除全埋点上报；
  clearFullReport();
  checkReady()
    .then(() => {
      const params = {};
      extBiParams = extBiParams || {};
      const qluin = getUin();

      //如果上报的时候需要登录态，但取不到qluin，就直接return
      if (report_need_login && !qluin) {
        return;
      }

      const biParams = {
        furl: getCurPage(),
        fopenid: qluin,
        fuin: qluin,
        fsource: report_source,
        fadtag: getAdtag(),
        fhost: location.host,
        fpathname: location.pathname
      };
      const finalBiParams = Object.assign({}, globalExtraBiParam, biParams, extBiParams);
      MtaStat.sendByMta(tag, params, finalBiParams);
      console.log(`## bi_report ##  ${tag}`, biParams);
      //给第三方插件，做收集上报数据用
      window.$$__thirdPart && window.$$__thirdPart.onmessage
        ? window.$$__thirdPart.onmessage('bi_report', { tag, extBiParams })
        : '';
    })
    .catch(err => {
      console.log('mta初始化请求超时', err);
    });
}

//原mta上报
export function hottag(...args) {
  //deprecated
  throw new Error('hottag is deprecated!');
}

//pv/uv上报
export function pgv(extBiParams) {
  checkReady()
    .then(() => {
      const qluin = getUin();
      const biParams = {
        furl: getCurPage(),
        fopenid: qluin,
        fuin: qluin,
        fsource: report_source,
        fadtag: getAdtag(),
        fhost: location.host,
        fpathname: location.pathname
      };
      const param = Object.assign({}, biParams, extBiParams);
      MtaStat.pgv(null, param);
    })
    .catch(err => {
      console.log('mta初始化请求超时', err);
    });
}
